import React from 'react';
import styled from 'styled-components';
import { Tag as AntdTag } from 'antd';
import { TagProps as AntdTagProps } from 'antd/lib/tag';
import { featureEnabled } from 'utils';
import { Color } from '@bb/elements-web-rebranding';
import theme, { ColorNameType } from '../theme';

type AntdTagColorNameType = AntdTagProps['color'];

const antdTagColors: AntdTagColorNameType[] = [
  'pink',
  'red',
  'yellow',
  'orange',
  'cyan',
  'green',
  'blue',
  'purple',
  'geekblue',
  'magenta',
  'volcano',
  'gold',
  'lime',
];

const isAntdTagColor = (
  color: ColorNameType | AntdTagColorNameType,
): color is AntdTagColorNameType => antdTagColors.includes(color);

export interface TagProps extends AntdTagProps {
  color?: ColorNameType | AntdTagColorNameType;
  colorVariant?: any;
  fontColor?: ColorNameType;
  hideMargin?: boolean;
}

const getUpdatedColor = (color: string) => {
  if (featureEnabled('supraRebrandingFeature', 1) && color === 'primary') {
    return Color.PRIMARY;
  }
  return isAntdTagColor(color) ? color : theme.getColor(color);
};

export const Tag: React.FC<TagProps> = ({
  color = 'primary',
  hideMargin,
  fontColor,
  ...props
}) => {
  const updatedColor = getUpdatedColor(color);
  return (
    <StyledTag
      color={updatedColor}
      $fontColor={fontColor}
      $hideMargin={hideMargin}
      {...props}
    />
  );
};

const StyledTag = styled(AntdTag)<{
  $fontColor: string;
  $hideMargin?: boolean;
}>`
  ${({ $fontColor }) => $fontColor && `color: ${$fontColor}`};
  ${({ $hideMargin }) => $hideMargin && `margin: 0`};
`;

export default styled(Tag)``;
